import { QuestionBase } from './question-base';
import { OptionQuestion } from './question-option';

export class RadioButtonQuestion extends QuestionBase<string> {
    controlType = 'radiobutton';
    options: OptionQuestion[] = [];

    constructor(options: {} = {}) {
        super(options);
        this.options = options['options'] || [];
    }
}
